import { render, staticRenderFns } from "./eztDetail.vue?vue&type=template&id=3b233c3c&scoped=true&"
import script from "./eztDetail.vue?vue&type=script&lang=js&"
export * from "./eztDetail.vue?vue&type=script&lang=js&"
import style0 from "./eztDetail.vue?vue&type=style&index=0&id=3b233c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b233c3c",
  null
  
)

export default component.exports